import { QueryFeature } from '../../../../../../config/queryClient';

enum QueryKey {
  ExternalAccountProvidersPoll = 'ExternalAccountProvidersPoll',
}

export const queryKeys = {
  externalAccountProvidersPoll: (clientId: number, contextId: string) => [
    QueryFeature.AddAccountsModal,
    QueryKey.ExternalAccountProvidersPoll,
    clientId,
    contextId,
  ],
};
